import gql from 'graphql-tag';

export default gql`
  mutation paymentOrderAdd($shipment_id: ID!) {
    paymentOrderAdd(shipment_id: $shipment_id) {
      succeed
    }
  }
`;
